import { createContext, useContext } from 'react';
import type { StrategyNode } from '../types/BaseNode';
import type { ErrorNode } from '../types/ErrorNode';

export interface NodeOperations {
    onUpdate: (id: string, updated: StrategyNode) => void;
    onDelete: (id: string) => void;
    onWrapInComposite: (id: string) => void;
    onWrapInFormatter: (id: string) => void;
    onCalculate: (node: StrategyNode) => void;
    onMakeRoot: (id: string) => void;
    onPromoteToParent: (id: string) => void;
    onStrategySaved?: () => void;
    toggleCollapsed: (id: string) => void;
    isCollapsed: (id: string) => boolean;
    errorNode: ErrorNode | null;
    onCreateStrategyFromNode: (node: StrategyNode) => void;
    rootNode: StrategyNode | null;
    reportDimensions: (id: string, width: number, height: number) => void;
    updateNodeMetadata: (metadata?: Record<string, unknown>) => void;
    updatePreviewResult: (response: unknown, nodeId: string) => void;
    globalStart?: string | null;
    globalEnd?: string | null;
    setElevatedId: (id: string | null) => void;
    isInteractionLocked: boolean;
}

export const NodeOperationsContext = createContext<NodeOperations | null>(null);

export function useNodeOperations() {
    const context = useContext(NodeOperationsContext);
    if (!context) {
        throw new Error('useNodeOperations must be used within a NodeOperationsProvider');
    }
    return context;
}
